import {
  getRequestTransportErrorMessage,
  getSafeServerErrorMessage,
} from '#/utils/requestError';

export function getBomApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code || data?.error?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'BOM_NOT_FOUND') {
    return data?.message || '找不到 BOM 資料';
  }

  if (code === 'BOM_INACTIVE') {
    return data?.message || '只能關聯啟用中的 BOM';
  }

  if (code === 'BOM_UPDATE_FIELD_NOT_ALLOWED') {
    return data?.message
      || '欄位已更新，請勿使用舊的 materials／extra_materials';
  }

  if (code === 'BOM_MATERIAL_QTY_READ_ONLY') {
    return data?.message || '群組物料數量由部位自動計算，不可寫入';
  }

  if (code === 'BOM_EXTRA_MATERIAL_QTY_INVALID') {
    return formatExtraMaterialQtyMessage(data);
  }

  if (code === 'UPDATED_AT_REQUIRED' || code === 'UPDATED_AT_INVALID') {
    return data?.message || '更新時間無效，請重新載入後再試';
  }

  if (code === 'BOM_STATUS_INVALID_FOR_ACTIVATE') {
    return data?.message || '目前狀態無法啟用';
  }

  if (code === 'BOM_STATUS_INVALID_FOR_DEACTIVATE') {
    return data?.message || '目前狀態無法停用';
  }

  if (code === 'TEMPLATE_NOT_FOUND') {
    return data?.message || '找不到 Excel 模板';
  }

  if (code === 'TEMPLATE_INVALID') {
    return data?.message || 'Excel 模板無效';
  }

  const serverMessage = getSafeServerErrorMessage(error, fallback);
  if (serverMessage) {
    return serverMessage;
  }

  return data?.message || fallback;
}

/** `field` 例 `extra_mtrs[2].qty` → 指出第 3 筆附加物料。 */
function formatExtraMaterialQtyMessage(data) {
  const base = '附加物料數量須大於 0（四捨五入至六位小數後）且小於 1,000,000,000,000';
  const match = /extra_mtrs\[(\d+)\]/.exec(String(data?.field ?? ''));
  return match ? `第 ${Number(match[1]) + 1} 筆${base}` : base;
}

export function isBomVersionConflict(error) {
  const data = error?.response?.data;
  return (data?.code || data?.error?.code) === 'RESOURCE_VERSION_CONFLICT';
}
